import { get } from 'lodash';
import { AxiosClient } from 'src/configs/axios/axios';

const PAGE_API = {
  listPageAPI: async (params: Page.GetListPageParams) => {
    const response = await new AxiosClient().get('/page', { params })
    return get(response, 'data', null)
  },
  detailPageAPI: async (id: string) => {
    const response = await new AxiosClient().get(`/page/${id}`)
    return get(response, 'data', null)
  },
  createPageAPI: async (params: Page.PagePostDetailParams) => {
    const response = await new AxiosClient().post('/page', params)
    const data = get(response, 'data', null)
    return data
  },
  updatePageAPI: async (params: Page.PagePostDetailParams) => {
    const response = await new AxiosClient().put(
      `/page/${params.id}`,
      params
    )
    const data = get(response, 'data', null)
    return data
  },
  deletePageAPI: async (id: string) => {
    const response = await new AxiosClient().delete('/page/' + id)
    const data = get(response, 'data', null)
    return data
  },
  settingShowPageAPI: async (id: string) => {
    const response = await new AxiosClient().put('/page/setting' + id)
    const data = get(response, 'data', null)
    return data
  },
}

export default PAGE_API
